
import { monthDateYearFormatter, monthDayFormatter } from './DateFormatter';

// Convert start date and end date in YYYY-MM-DD format to MMMM DD, YYYY format
// "2025-07-05" to "July 5, 2025"
function getFormattedDateBasedOnStringDateAndDuration(startDateInYYYYMMDD: string, endDateInYYYYMMDD: string) : string {

    const startDate = new Date(startDateInYYYYMMDD.replace(/-/g, '/'));
    const endDate = new Date(endDateInYYYYMMDD.replace(/-/g, '/'));

    return startDate.getTime() === endDate.getTime() 
            ? monthDateYearFormatter.format(startDate)
            : `${monthDayFormatter.format(startDate)} - ${monthDateYearFormatter.format(endDate)}` ;
}

function getFirstDateOfWeek(date: Date): Date {
  const firstDate = new Date(date);
  firstDate.setDate(date.getDate() - date.getDay());
  firstDate.setHours(0, 0, 0, 0);
  return firstDate;
}

function getLastDateOfWeek(date: Date): Date {
  const lastDate = getFirstDateOfWeek(date);
  lastDate.setDate(lastDate.getDate() + 6);
  lastDate.setHours(23, 59, 59, 999);
  return lastDate;
}

function parseDate(dateString: string): Date {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
}

function getLocalDate (
  year: number,
  month: number,
  day: number,
  hour = 0,
  minute = 0,
  second = 0
) {
  return new Date(year, month - 1, day, hour, minute, second);
};

function formatDateToYYYYMMDD(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function doDateRangesOverlap(
  rangeAStart: Date,
  rangeAEnd: Date,
  rangeBStart: Date,
  rangeBEnd: Date
): boolean {
  return rangeAStart <= rangeBEnd && rangeAEnd >= rangeBStart;
}

export { 
  getFirstDateOfWeek, 
  getLastDateOfWeek, 
  getFormattedDateBasedOnStringDateAndDuration, 
  parseDate, 
  formatDateToYYYYMMDD, 
  doDateRangesOverlap, 
  getLocalDate
 };